var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShowHides(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "show-hide",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9811",
    "data-name": "Group 9811",
    transform: "translate(-927 -52)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3627",
    "data-name": "Path 3627",
    d: "M15,0A15,15,0,1,1,0,15,15,15,0,0,1,15,0Z",
    transform: "translate(927 52)",
    fill: "#3c3838",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10511",
    "data-name": "Path 10511",
    d: "M176.493,189.391a.651.651,0,0,0-.474.209l-7.33,7.806a.746.746,0,0,0,0,1.008.641.641,0,0,0,.947,0l6.857-7.3,6.857,7.3a.641.641,0,0,0,.947,0,.746.746,0,0,0,0-1.008l-7.331-7.805a.65.65,0,0,0-.474-.209Z",
    transform: "translate(765.507 -126.738)",
    fill: "#3c3838"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowHides);
export default __webpack_public_path__ + "static/media/show-hides.97e90f846e7a16d386b64733fda7a4fe.svg";
export { ForwardRef as ReactComponent };